<template>
  <svg class="logo-icon" :class="{ animating: isLoading }" :style="iconStyle" width="92px" height="71px" viewBox="0 0 92 71" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <polygon :fill="isLight ? '#123C4C' : '#123C4C'" points="45.9 53 56.1 56 61.2 61.8 45.9 70.6 30.6 61.8 36.6 56.1"></polygon>
      <polygon :fill="isLight ? '#12466D' : '#12466D'" points="30.6 44.1 45.9 53 38.2 57.4 30.6 61.8 15.3 53 22.6 46.3"></polygon>
      <polygon :fill="isLight ? '#12466D' : '#12466D'" points="61.2 44.1 69.1 46.5 76.5 53 61.2 61.8 53.5 57.4 45.9 53"></polygon>
      <polygon :fill="isLight ? '#165D91' : '#165D91'" points="61.2 44.1 61.2 26.5 69.3 29.3 76.5 35.3 76.5 53"></polygon>
      <polygon :fill="isLight ? '#165D91' : '#165D91'" points="30.6 44.1 30.6 26.5 22.7 29 15.3 35.3 15.3 53"></polygon>
      <polygon fill="#000000" fill-rule="nonzero" fill-opacity="0.1" points="30.6 26.5 22.7 29 15.3 35.3 30.6 29.3"></polygon>
      <polygon fill="#000000" fill-rule="nonzero" fill-opacity="0.1" points="61.2 26.5 69.1 29 76.5 35.3 61.2 29.3"></polygon>
      <polygon :fill="isLight ? '#66B6F2' : '#1A6BA8'" points="76.5 17.7 91.7 26.5 76.5 35.3 61.2 26.5 67.8 21.1"></polygon>
      <polygon :fill="isLight ? '#66B6F2' : '#1A6BA8'" points="15.3 17.7 0 26.5 15.3 35.3 30.6 26.5 25.2 20.2"></polygon>
      <polygon :fill="isLight ? '#AFD8F2' : '#1E88D8'" points="61.2 8.8 76.5 17.7 61.2 26.5 45.9 17.7 52.4 12.1"></polygon>
      <polygon :fill="isLight ? '#AFD8F2' : '#1E88D8'" points="30.6 8.8 15.3 17.7 30.6 26.5 45.9 17.7 40.2 12.4"></polygon>
      <polygon :fill="isLight ? '#FFFFFF' : '#1B90F5'" points="45.9 0 45.9 0 45.9 0 61.2 8.8 45.9 17.7 30.6 8.8"></polygon>
    </g>
  </svg>
</template>

<script>
  export default {
    props: {
      width: {
        type: Number,
        default: 60
      },

      isLoading: {
        type: Boolean,
        default: false
      },

      theme: {
        type: String,
        default: 'light',
        validator (value) {
          return ['light', 'dark'].indexOf(value) > -1
        }
      }
    },

    computed: {
      isLight () {
        return this.theme === 'light'
      },

      iconStyle () {
        return {
          width: `${this.width}px`,
          height: 'auto'
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// LogoIcon.vue?0df38ea1